// 계약 승인 유형
export const CONTRACT_APPROVAL_TYPE_OPTIONS = [
  { value: "AUTO", label: "자동승인" },
  { value: "ADMIN", label: "관리자승인" },
];

// 계약 승인 상태
export const CONTRACT_APPROVAL_STATUS_OPTIONS = [
  { value: "", label: "전체" },
  { value: "PENDING", label: "승인대기", tagColor: "status A", color: "color-blue2" },
  { value: "APPROVED", label: "승인완료", tagColor: "status B", color: "color-green2" },
  { value: "REJECTED", label: "반려", tagColor: "status D", color: "color-red2" },
];
